
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0)"}},[_c('path',{attrs:{"d":"M21.45 12.7a1.875 1.875 0 000-2.65L15.2 3.8a1.875 1.875 0 00-2.65 0l-10 10a1.875 1.875 0 000 2.65L6.3 20.2c.35.352.828.55 1.325.55h13.906c.26 0 .469-.21.469-.469V18.72a.469.469 0 00-.469-.469h-5.63l5.55-5.55zM9.63 10.255l5.366 5.367-2.63 2.629H7.884l-3.125-3.125 4.87-4.87z","fill":"#282E3E"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(2 2)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    